module.exports = __webpack_public_path__ + "static/media/06-2.aaa77dc4.webp";